import { blueGrey } from "@mui/material/colors";
import { useNavigate } from "react-router-dom";

import ArrowRightSVG from "../../../media/images/icons/arrow-right";
import CustomButton from "../CustomButton";

export default function NavBackButton() {
  const navigate = useNavigate();

  return (
    <CustomButton
      justifyContent='space-between'
      onClick={() => navigate(-1)}
      bgColor={blueGrey[400]}
      title='بازگشت'
      fSize='14px'
      fWeight='600'
      py='8px'
      px='8px'
      gap='4px'
      borderRadius='10px'
      textColor='lightStatic.main'
      icon1={<ArrowRightSVG size={26} color={"#fff"} />}
    />
  );
}
